module.exports = __webpack_public_path__ + "img/sti-active.706fb445.svg";